import { DisplayMode } from "./DepartmentPlan";

export function parseDisplayMode(raw: number): DisplayMode {
    if (isNaN(raw)) return 1;

    if ([1, 3, 7].every(p => p !== raw)) return 1;

    return raw as DisplayMode;
}
